import React from 'react';

import * as hf from './_hf';
import * as ht from './_ht';
import * as f from './_cmFTH';
import * as cr from './_cr';

import * as l from "./_csLcl";
import { a } from "./_csAbt";
import { useMsgz } from "./_csMdlMsg";

import * as BoxC from './_ccbBoxC';
import * as GridC from './_cccGridC';
import * as IptC from './_ccbIptC';
import * as LblC from './_cccLblC';
import * as BtnCttC from './_ccmBtnCttC';

import * as ica from 'src/ica';

import * as _cv_10___Mz from './_cv_10___Mz';

let $_10z = _cv_10___Mz.ilz_10z();

export const B = (pz: ht.viewDtlCz) => {
  const _sMsgz = useMsgz();
  return (
    cr.c(BtnCttC.N, {
      key: -10,
      ... pz,
      cz: {
        ... pz.cz,
        ugdAsync: async () => {
          const _b = await hf.ectSrlAsync([
            async () => { // 必須項目の確認
              let _b = true;
              if (
                !hf.f($_10z._10rz._icn) ||
                !hf.f($_10z._10rz._pfx) ||
                !hf.f($_10z._10rz._10ra2100s) ||
                !hf.f($_10z._101z._101a1100s)
              ) _b = false;
              if (!_b) {
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '必須項目が入力されていないため、指定された操作を行うことができません',
                    }
                  }
                })
              }
              return _b;
            },
            async () => {
              let _b = true;
              let _cdn = f.vdd(false) + ` AND _icn = '${$_10z._10rz._icn}'`;
              if ($_10z._10rz._key > 0) _cdn += ` AND _key <> ${$_10z._10rz._key}`;
              const _ls = await _cv_10___Mz.load_10rLsAsync({
                cdn: _cdn,
              })
              if (hf.f(_ls)) {                
                _b = false;
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: '利用者IDが他の利用者と重複しているため、登録することができません',
                    }
                  }
                });
              }
              return _b;
            },
            async () => {
              let _b = true;
              let _cdn = f.vdd(false) + ` AND _10ra2100s = '${$_10z._10rz._10ra2100s}'`;
              if ($_10z._10rz._key > 0) _cdn += ` AND _key <> ${$_10z._10rz._key}`;
              const _ls = await _cv_10___Mz.load_10rLsAsync({
                cdn: _cdn,
              })
              if (hf.f(_ls)) {                
                _b = false;
                _sMsgz.show({
                  textCz: {
                    textz: {
                      pfx: 'ログインIDが他の利用者と重複しているため、登録することができません',
                    }
                  }
                });
              }
              return _b;
            },
          ]);
          if (_b) {
            const _10z = await _cv_10___Mz.save_10rDzAsync({
              //... pz,
              _10z: $_10z,
              cdn: 'true',
            });
            //hf.l(`_cv_10b 35: ${hf.s(_10z)}`)
            const _dz = {
              _10r_key: _10z._10rz._key,
            }
            //hf.l(`_cv_10b 39: ${hf.s(_dz)}`)
            return _dz
          }
          else {
            return undefined;
          }
        }
      }
    })
  );
};

export const D = (pz: ht.viewDtlCz) => {

  const _frcUdt = l.frcUdt();
  
  React.useEffect(() => {
    f.loadAllAsync({
      phs: pz.sPz.crt.phs,
      frcUdt: _frcUdt,
      crtAsync: () => [
        _cv_10___Mz.crt_10z({
          itlz: pz.cz.itlz
        })
        .then((_dz: ht.dz) => {
          $_10z = _dz;
        })
      ],
      udtAsync: () => [
        _cv_10___Mz.load_10rDzAsync({
          _10r_key: pz.sPz.crt._10r_key,
          cdn: 'true',
          lwrType: -1,
        })
        .then(async (_dz: ht.dz) => {
/*
        .then(async (_dz1: ht.dz) => {
//hf.l(`_cv_10___Ci 68: ${hf.s(_dz1)}`);
          await _cv_10.load_101DzAsync({
            _10r_key: _dz1._10rz._key,
            cdn: 'true',
          })
          .then((_dz2: ht.dz) => {
//hf.l(`_cv_10___Ci 73: ${hf.s(_dz2)}`);
            $_10z = {
              _10rz: _dz1._10rz,
              _101z: _dz2._101z,
            };
          })
*/
          $_10z = _dz;
        })
      ]
    });
  }, [
    pz.sPz.crt.phs,
    pz.sPz.crt._10r_key
  ])

  const _abtType = pz.abtType ?? 'nmlz';
  const _abtz = ica.viewDtlAbtz[_abtType] ? ica.viewDtlAbtz[_abtType]() : {};

  //hf.l(`_cv_10b 95: here`);
  return (
    cr.c(BoxC.N, {
      key: -10,
      boxStlz: a('dw/f fd/csc'),
      oClds: [
        cr.c(GridC.N, {
          key: -20,
          abtType: 'nolineCmnz',
          boxStlz: a('dw/f dwx/60 mb/2'),
          lineCs: [
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '利用者ID：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ,
                              iptType: 'text',
                              vle: $_10z?._10rz._icn ?? '',
                              onChg: ( _s: ht.s ) => {
                                $_10z._10rz._icn = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: '利用者名：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ,
                              iptType: 'text',
                              vle: $_10z?._10rz._pfx ?? '',
                              onChg: ( _s: ht.s ) => {
                                $_10z._10rz._pfx = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: 'ログインID：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ,
                              iptType: 'text',
                              vle: $_10z?._10rz._10ra2100s ?? '',
                              onChg: ( _s: ht.s ) => {
                                $_10z._10rz._10ra2100s = _s;
                              },
                            }
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
            {
              boxStlz: a(`mb/1`),
              cellCs: [
                {
                  oClds: [
                    cr.c(LblC.N, {
                      key: -10,
                      ... _abtz.crtz.lblCz,
                      lblCz: {
                        boxStlz: a(`dw/14`),
                        textz: {
                          pfx: 'パスワード：',
                        }
                      },
                      cttCz: {
                        oClds: [
                          cr.c(IptC.S, {
                            key: -10,
                            cz: {
                              bEdit: hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ,
                              iptType: 'text',
                              vle: 
                                hf.i(pz.sPz.crt.phs, ['crt', 'udt']) ?
                                  $_10z?._101z?._101a1100s ?? ''
                                : hf.pdg('', ($_10z?._101z?._101a1100s ?? '').length, '●'),
                              onChg: ( _s: ht.s ) => {
                                $_10z._101z._101a1100s = _s;
                              },
                            },
                          })
                        ],
                      },
                      omtCz: 
                        hf.i(pz.sPz.crt.phs, [`crt`, `udt`]) ?
                        {
                          abtType: 'omtRqrCmnz',
                        }
                        : undefined,
                    }),
                  ]
                },
              ]
            },
          ]
        })
      ]
    })
  );
};
